import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import { ContentProvider, useContent } from "@/context/ContentContext";
import { ShowreelProvider } from "@/components/site/Showreel";
import { Analytics } from "@/components/site/Analytics";
import { Grain } from "@/components/site/Grain";
import { Intro } from "@/components/site/Intro";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Stats } from "@/components/site/Stats";
import { Mission } from "@/components/site/Mission";
import { Association } from "@/components/site/Association";
import { Activities } from "@/components/site/Activities";
import { Realisations } from "@/components/site/Realisations";
import { Festival } from "@/components/site/Festival";
import { News } from "@/components/site/News";
import { LatestNews } from "@/components/site/LatestNews";
import { Formations } from "@/components/site/Formations";
import { Team } from "@/components/site/Team";
import { Testimonials } from "@/components/site/Testimonials";
import { Partners } from "@/components/site/Partners";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

const IntroGate = () => {
  const { content } = useContent();
  return <Intro config={content.intro} />;
};

// Ordered toggleable homepage blocks (id must match AdminBlocks + sectionsVisibility)
const BLOCKS = [
  { id: "latestNews", el: <LatestNews /> },
  { id: "stats", el: <Stats /> },
  { id: "mission", el: <Mission /> },
  { id: "association", el: <Association /> },
  { id: "activities", el: <Activities /> },
  { id: "realisations", el: <Realisations /> },
  { id: "festival", el: <Festival /> },
  { id: "news", el: <News /> },
  { id: "formations", el: <Formations /> },
  { id: "team", el: <Team /> },
  { id: "testimonials", el: <Testimonials /> },
  { id: "partners", el: <Partners /> },
  { id: "contact", el: <Contact /> },
];

const MainSections = () => {
  const { content } = useContent();
  const vis = content.sectionsVisibility || {};
  return (
    <main>
      <Hero />
      <Marquee />
      {BLOCKS.map((b) => (vis[b.id] === false ? null : <div key={b.id}>{b.el}</div>))}
    </main>
  );
};

export default function Site() {
  return (
    <ContentProvider>
      <ReactLenis root options={{ lerp: 0.08, duration: 1.2, smoothWheel: true }}>
        <ShowreelProvider>
          <IntroGate />
          <Analytics />
          <div className="App bg-[#050505]">
            <Grain />
            <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#181818", border: "1px solid rgba(62,155,255,0.4)", color: "#fff" } }} />
            <Navbar />
            <MainSections />
            <Footer />
          </div>
        </ShowreelProvider>
      </ReactLenis>
    </ContentProvider>
  );
}
